import { Controller } from "@hotwired/stimulus";
import { TypedController } from "@vytant/stimulus-decorators";

@TypedController
export default class extends Controller {
  connect() {
    const iframe = this.element.querySelector<HTMLIFrameElement>("iframe");
    if (!iframe) return;

    iframe.addEventListener("load", () => {
      const tabContent = iframe.parentElement as HTMLDivElement;
      if (!tabContent) return;

      tabContent.classList.remove("loading");
    });
  }
}
